<template>
    <div class="contato">
        <Header></Header>
        <div class="container">
            <div class="row mt-5 mb-4">
                <div class="col-12">
                    <span class="txt-p txt-size-25 txt-w-bold txt-roxo-1">{{labels[0]}}</span>
                </div>
            </div>
            <div class="row mb-5">                
                <div class="col-6">
                    <p class="txt-p txt-cores-5 mb-4 recuo">
                        {{labels[1]}}
                    </p>

                    <div class="box-contato d-flex mb-2" v-for="(item,index) in contatos" :key="index">
                        <div class="box-contato-icone txt-p txt-cores-5 txt-w-bold me-2">
                            <i :class="'fas '+item.icon"></i>
                        </div>
                        <div class="box-contato-dados">
                            <p class="txt-p txt-cores-5 txt-w-bold mb-2">
                                {{item.nome}}:
                            </p>
                            <p class="txt-p txt-cores-5 txt-w-bold mb-2">
                                {{item.telefone}}
                            </p>
                            <p class="txt-p txt-cores-5">
                                {{item.email}}
                            </p>
                        </div>
                    </div>

                </div>
                <div class="col-6">
                    <FormContato class=""></FormContato>
                </div>
            </div>
        </div>

        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import FormContato from '@/components/FormContato'

    export default {
        name: 'Contato',
        components: { Header, Footer, FormContato },
        data: function () {
            return {
                labels: [
                    "Entre em contato conosco!",
                    "Deseja fazer alguma observação, elogio, sugestão, reclamação ou só conversar conosco? Utilize um dos meios de contato abaixo ou preencha nosso formulário que voltaremos com uma resposta o mais rápido possível.",
                ],
                contatos: [
                    { icon: 'fa-phone-alt', nome: 'Contato', telefone: '+55 (41) 98862-3426', email:'contato@sollicita.com'},
                    { icon: 'fa-headset', nome: 'Suporte', telefone: '+55 (41) 98862-3426', email:'suporte@sollicita.com'}
                ],
            }
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    
</style>

